import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { StoreContext } from "../../../Store/Provider";
import Drawer from "@material-ui/core/Drawer";
import Sidebar from "../Home/Sidebar/Sidebar";
import Header from "../Home/Header/Header";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getUserData, localStoragekey } from "../../Common/Utility/Utils";
import { HOST_URL } from "../../../Config";
import Backdrop from "@material-ui/core/Backdrop";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InfiniteScroll from "react-infinite-scroller";
import PropagateLoader from "react-spinners/PropagateLoader";
import axios from "axios";
import moment from "moment";
import "./statement.css";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ImportExportIcon from "@mui/icons-material/ImportExport";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Statement() {
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  const context = useContext(StoreContext);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasmore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(true);
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const [sortOrder, setSortOrder] = useState("");
  const [sortCriteria, setSortCriteria] = useState("");
  const [isMount, setIsMount] = useState(false);
  const [statementData, setStatementData] = useState({
    loaded: false,
    data: [],
  });

  useEffect(() => {
    setIsMount(true);
    if (!statementData.loaded) {
      getdata(pageNumber);
    }

    return () => {
      context.setsearchText("");
    };
  }, []);

  useEffect(() => {
    if (isMount) {
      setPageNumber(1);
      setHasMore(false);
      setStatementData({
        loaded: true,
        data: [],
      });
      getdata(1);
    }
  }, [context.searchText]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  const getdata = async (pageNumber) => {
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    const URL = `${HOST_URL}api/v1/AccountStatement/Get`;
    const body = {
      companyCode: userData.orgs,
      pageNumber: pageNumber,
      pageSize: 20,
      sortOrder: sortOrder,
      sortCriteria: sortCriteria,
      SearchText: context?.searchText ?? "",
    };
    axios
      .post(URL, body, {
        headers: header,
      })
      .then((res) => {
        let hasMorecheck = res.data.transactions.length === 20 ? true : false;
        setHasMore(hasMorecheck);
        if (pageNumber === 1) {
          setStatementData({
            loaded: true,
            data: [...res.data.transactions],
          });
        } else {
          setStatementData({
            loaded: true,
            data: [...statementData.data, ...res.data.transactions],
          });
        }
        let count = pageNumber + 1;
        setPageNumber(count);
        setLoadingMore(true);
      })
      .catch((res) => {
        console.log(res);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const loadMore = () => {
    if (loadingMore) {
      getdata(pageNumber);
      setLoadingMore(false);
    }
  };

  const onDocDownload = async (row) => {
    setOpen(true);
    const params = {
      DocumentType: ["INV"],
      IsPublish: true,
    };
    const URL = `${HOST_URL}api/v1/Document/CWDocumentData/INV/AR INV ${row.TransactionNumber}`;
    axios
      .post(URL, params)
      .then((res) => {
        const downloadLink = document.createElement("a");
        downloadLink.href = `data:application/pdf;base64,${res.data[0]?.ImageData}`;
        downloadLink.download = res.data[0]?.FullName;
        downloadLink.click();
        setOpen(false);
        console.log(res);
      })
      .catch((err) => {
        setOpen(false);
        setOpenalert(true);
        setSeverity("error");
        setAlertText("Something went wrong!");
      });
  };

  const sort = async (sortCriteria, SortBy) => {
    setPageNumber(1);
    setSortOrder(SortBy);
    setSortCriteria(sortCriteria);
    setHasMore(true);
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData.access_token}`,
      username: `${userData.userName}`,
      grant_type: "password",
      password: `${userData.userSecret}`,
    };
    const URL = `${HOST_URL}api/v1/AccountStatement/Get`;
    const body = {
      sortCriteria: sortCriteria,
      statusCode: "",
      DueDate: "",
      TransactionDate: "",
      SearchText: context?.searchText ?? "",
      companyCode: "",
      countryCode: "",
      sortOrder: SortBy,
      pageNumber: 1,
      pageSize: 20,
    };

    axios
      .post(URL, body, {
        headers: header,
      })
      .then((res) => {
        setStatementData({
          loaded: true,
          data: [...res.data.transactions],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          <div className="shipmentsListingHomeInner statmentScreen">
            {!statementData.loaded ? (
              <div className="loadingClass">
                <PropagateLoader color={"#fff"} size={"1.5rem"} />
              </div>
            ) : (
              <div className="statementBody">
                {statementData.data.length ? (
                  <TableContainer style={{ height: "100%" }}>
                    <InfiniteScroll
                      pageStart={0}
                      loadMore={loadMore}
                      hasMore={hasmore}
                      loader={
                        <div className="bottomLoader">
                          <CircularProgress size="1.5rem" />
                        </div>
                      }
                      useWindow={false}
                    >
                      <Table stickyHeader style={{ minWidth: "85rem" }}>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("TransactionNumber", "Desc");
                                } else {
                                  sort("TransactionNumber", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom" }}
                            >
                              Invoice{" "}
                              {sortCriteria === "TransactionNumber" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("JobInvoiceNumber", "Desc");
                                } else {
                                  sort("JobInvoiceNumber", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom" }}
                            >
                              Shipment{" "}
                              {sortCriteria === "JobInvoiceNumber" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("PONumber", "Desc");
                                } else {
                                  sort("PONumber", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom" }}
                            >
                              PO Number{" "}
                              {sortCriteria === "PONumber" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("BLNumber", "Desc");
                                } else {
                                  sort("BLNumber", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom" }}
                            >
                              BL Number{" "}
                              {sortCriteria === "BLNumber" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("CustomerOrganizationCode", "Desc");
                                } else {
                                  sort("CustomerOrganizationCode", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom", width: "9rem" }}
                            >
                              Org Code{" "}
                              {sortCriteria === "CustomerOrganizationCode" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("DueDate", "Desc");
                                } else {
                                  sort("DueDate", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom" }}
                            >
                              Due Date{" "}
                              {sortCriteria === "DueDate" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>

                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("TransactionDate", "Desc");
                                } else {
                                  sort("TransactionDate", "Asc");
                                }
                              }}
                              align="left"
                              style={{ verticalAlign: "bottom" }}
                            >
                              Invoice Date{" "}
                              {sortCriteria === "TransactionDate" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => {
                                if (sortOrder === "Asc") {
                                  sort("LocalTotal", "Desc");
                                } else {
                                  sort("LocalTotal", "Asc");
                                }
                              }}
                              align="right"
                              style={{ verticalAlign: "bottom", width: "8rem" }}
                            >
                              Invoiced Amount{" "}
                              {sortCriteria === "LocalTotal" ? (
                                sortOrder === "Asc" ? (
                                  <ArrowUpwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{
                                      fontSize: "0.8rem",
                                      display: "initial",
                                    }}
                                  />
                                )
                              ) : (
                                <ImportExportIcon
                                  style={{
                                    fontSize: "0.8rem",
                                    display: "initial",
                                  }}
                                />
                              )}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                verticalAlign: "bottom",
                                paddingTop: "0",
                                paddingBottom: "0.01rem",
                                width: "20rem",
                              }}
                            >
                              {"Outstanding Balance (in days)"}
                              <Table className="subTable">
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      align="right"
                                      style={{
                                        width: "3rem",
                                        border: "none",
                                        paddingBottom: "0",
                                      }}
                                    >
                                      {"0-30"}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      style={{
                                        width: "3rem",
                                        border: "none",
                                        paddingBottom: "0",
                                      }}
                                    >
                                      {"31-60"}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      style={{
                                        width: "3rem",
                                        border: "none",
                                        paddingBottom: "0",
                                      }}
                                    >
                                      {"61-90"}
                                    </TableCell>
                                    <TableCell
                                      align="right"
                                      style={{
                                        width: "3rem",
                                        border: "none",
                                        paddingBottom: "0",
                                      }}
                                    >
                                      {">90"}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                              </Table>
                            </TableCell>
                            <TableCell
                              align="right"
                              style={{ verticalAlign: "bottom" }}
                            >
                              Download
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {statementData.data.map((row, index) => {
                            const uniqueClass = `rowId-${index}`;
                            return (
                              <TableRow
                                hover
                                tabIndex={-1}
                                key={index}
                                className={
                                  moment(row.DueDate).diff(moment(), "days") <=
                                  0
                                    ? `${uniqueClass} overdue`
                                    : `${uniqueClass} overdue`
                                }
                              >
                                <TableCell
                                  align="left"
                                  title={row.TransactionNumber}
                                >
                                  {row.TransactionNumber}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  title={row.JobInvoiceNumber}
                                >
                                  {row.JobInvoiceNumber}
                                </TableCell>
                                <TableCell align="left" title={row.PONumber}>
                                  {row.PONumber ? row.PONumber : ""}
                                </TableCell>
                                <TableCell align="left" title={row.BLNumber}>
                                  {row.BLNumber ? row.BLNumber : ""}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  title={row.CustomerOrganizationName}
                                >
                                  {row.CustomerOrganizationCode
                                    ? row.CustomerOrganizationCode
                                    : ""}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  title={moment(row.DueDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                >
                                  {row.DueDate
                                    ? moment(row.DueDate).format("DD/MM/YYYY")
                                    : "N/A"}
                                </TableCell>
                                <TableCell
                                  align="left"
                                  title={moment(row.TransactionDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                >
                                  {row.TransactionDate
                                    ? moment(row.TransactionDate).format(
                                        "DD/MM/YYYY"
                                      )
                                    : "N/A"}
                                </TableCell>
                                <TableCell align="right">
                                  {row.OSCurrencyCode}{" "}
                                  {context.calculateAmmount(row.OSTotal)}
                                </TableCell>
                                <TableCell align="center">
                                  <Table className="subTable">
                                    <TableBody>
                                      <TableRow>
                                        <TableCell
                                          align="right"
                                          style={{
                                            width: "3rem",
                                            border: "none",
                                          }}
                                        >
                                          {row?.OverDueSpan1
                                            ? row.OSCurrencyCode +
                                              " " +
                                              row.OverDueSpan1
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          style={{
                                            width: "3rem",
                                            border: "none",
                                          }}
                                        >
                                          {row?.OverDueSpan2
                                            ? row.OSCurrencyCode +
                                              " " +
                                              row.OverDueSpan2
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          style={{
                                            width: "3rem",
                                            border: "none",
                                          }}
                                        >
                                          {row?.OverDueSpan3
                                            ? row.OSCurrencyCode +
                                              " " +
                                              row.OverDueSpan3
                                            : "-"}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          style={{
                                            width: "3rem",
                                            border: "none",
                                          }}
                                        >
                                          {row?.OverDueSpan4
                                            ? row.OSCurrencyCode +
                                              " " +
                                              row.OverDueSpan4
                                            : "-"}
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableCell>
                                <TableCell align="left">
                                  <div className="actionTableData">
                                    <Button
                                      title="Download"
                                      className="statementDownload"
                                      onClick={() => onDocDownload(row)}
                                    >
                                      <i className="fas fa-download" />
                                    </Button>
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </InfiniteScroll>
                  </TableContainer>
                ) : (
                  <span className="noShipmentsDiv">Statement not found!</span>
                )}
              </div>
            )}
          </div>
        </main>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>

      <Backdrop className={classes.backdrop} open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default Statement;
